import React from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/lib/format";
import { PageHeader, DataTable, useList } from "@/components/shared";
import { FormDialog } from "@/components/EntityForm";
import { Button } from "@/components/ui/button";
import { Building2, Plus, Phone, Globe } from "lucide-react";

export default function Insurers() {
  const { hasPerm } = useAuth();
  const { items, loading, refetch } = useList("/insurers", {});
  const create = async (v) => { await api.post("/insurers", v); refetch(); };
  const fields = [
    { name: "name", label: "Company Name", required: true },
    { name: "company_type", label: "Type", type: "select", options: ["General", "Health", "Life"] },
    { name: "customer_care", label: "Customer Care" },
    { name: "claims_helpline", label: "Claims Helpline" },
    { name: "toll_free", label: "Toll-Free" },
    { name: "email", label: "Email", type: "email" },
    { name: "website", label: "Website" },
    { name: "working_hours", label: "Working Hours" },
    { name: "sla", label: "SLA" },
    { name: "internal_notes", label: "Internal Notes", type: "textarea", full: true },
  ];
  const columns = [
    { key: "name", header: "Insurer", render: (r) => <div><div className="font-semibold">{r.name}</div><div className="text-xs text-muted-foreground">{r.company_type}</div></div> },
    { key: "customer_care", header: "Customer Care", render: (r) => <span className="font-mono text-xs">{r.customer_care || "—"}</span> },
    { key: "claims_helpline", header: "Claims", render: (r) => <span className="font-mono text-xs">{r.claims_helpline || "—"}</span> },
    { key: "website", header: "Website", render: (r) => r.website ? <a href={r.website} target="_blank" rel="noreferrer" className="text-primary text-sm inline-flex items-center gap-1"><Globe className="h-3.5 w-3.5" />Visit</a> : "—" },
    { key: "sla", header: "SLA", render: (r) => <span className="text-sm">{r.sla || "—"}</span> },
    { key: "active", header: "Status", render: (r) => <StatusBadge value={r.active ? "active" : "inactive"} /> },
  ];
  return (
    <div>
      <PageHeader title="Insurer Master" subtitle="Editable insurer directory — no hard-coded contacts" icon={Building2}
        actions={hasPerm("insurers:add") && (
          <FormDialog title="Add Insurer" fields={fields} onSubmit={create} submitLabel="Add Insurer" testId="create-insurer-dialog"
            trigger={<Button data-testid="create-insurer-btn"><Plus className="h-4 w-4 mr-1.5" /> Add Insurer</Button>} />
        )} />
      <DataTable columns={columns} rows={items} loading={loading} rowTestId="insurer-table-row" />
    </div>
  );
}
